// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "manual_update_reason_id",
                Decco.intToJson(v.manual_update_reason_id)
              ],
              [
                "final_order_status",
                Decco.stringToJson(v.final_order_status)
              ],
              [
                "current_order_status",
                Decco.stringToJson(v.current_order_status)
              ],
              [
                "order_updated_at",
                Decco.floatToJson(v.order_updated_at)
              ],
              [
                "crn",
                Decco.stringToJson(v.crn)
              ],
              [
                "uuid",
                Decco.optionToJson(Decco.stringToJson, v.uuid)
              ],
              [
                "msisdn",
                Decco.optionToJson(Decco.stringToJson, v.msisdn)
              ],
              [
                "trip_accepted_time",
                Decco.optionToJson(Decco.floatToJson, v.trip_accepted_time)
              ],
              [
                "trip_started_time",
                Decco.optionToJson(Decco.floatToJson, v.trip_started_time)
              ],
              [
                "trip_ended_time",
                Decco.optionToJson(Decco.floatToJson, v.trip_ended_time)
              ],
              [
                "job_ended_time",
                Decco.optionToJson(Decco.floatToJson, v.job_ended_time)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
